import axios from 'axios';

export const getRegions = () => axios.get('/mop/regions');//
export const getDictionary = (number) => axios.get(`/mop/getdictionary/${number}`);// типы,формы,графики,категории
export const getResorts = () => axios.get('/mop/resort-titles');// названия
export const getReport = (id) => axios.get(`/mop/getreport/${id}`);
